<template>
  <div id="app">
    <BannerMessage v-if="authStatus"></BannerMessage>
    <pulse-loader :loading="isLoading"></pulse-loader>
    <!-- enter-active-class="animate__animated animate__fadeIn animate__fastest"
      leave-active-class="animate__animated animate__fadeOut animate__fastest" -->
    <LoginModal v-if="isAuthModalActive" :isLoginModalActive="isAuthModalActive"></LoginModal>
    <transition name="fade" mode="out-in">
      <router-view :key="$route.fullPath" />
    </transition>
    <NotificationBox />
  </div>
</template>

<script>
import PulseLoader from "@/components/vue-spinner/PulseLoader.vue";
import NotificationBox from "@/components/notification/NotificationBox.vue";
import LoginModal from "@/components/t-components/LoginModal.vue";
import BannerMessage from "@/components/t-components/BannerMessage.vue";
import { mapGetters } from "vuex";

export default {
  name: "App",
  components: {
    PulseLoader,
    NotificationBox,
    LoginModal,
    BannerMessage
  },
  computed: {
    ...mapGetters(["isLoading", "isAuthModalActive", "authStatus"]),
  },
  created() {
    if (!window.navigator.onLine) console.log("offline");
  },
  beforeMount () {
    if (this.getToken()) {
      this.$store.commit('setAuthStatus', true);
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: "Inter", sans-serif;
}

.animate__fastest {
  --animate-duration: 250ms;
}

.text-ellipses {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.tooltip-active {
  opacity: 1 !important;
  display: inherit;
}
// .carouselContainer button.slick-prev {
//   left: -20px;
//   width: 2rem;
//   height: 2rem;
//   margin-top: -1rem;
// }
// .carouselContainer button.slick-prev:before {
//   color: black;
//   font-size: 40px;
//   font-weight: bold;
// }
//    
// .carouselContainer .slick-slide {
//   margin: 0 10px;
//   margin-right: 1.5rem;
// }

// .carouselContainer .slick-list {
//   padding: 0px 0px 20px 0px; // 20px 5px 20px 5px;
// }

.twitter-cropper {
  height: 300px;
  &__background {
    background-color: #edf2f4;
  }
  &__foreground {
    background-color: #edf2f4;
  }
  &__stencil {
    border: solid 5px rgb(29, 161, 242);
  }
}

// @media only screen and (max-width: 420px) {
//   .carouselContainer button.slick-next {
//     // right: -16px;
//     right: 0px;
//     width: 1.5rem;
//     margin-top: -2rem;
//   }
//   .carouselContainer button.slick-prev {
//     left: -16px;
//     width: 1.5rem;
//     margin-top: -2rem;
//   }
// }

// @media only screen and (min-width: 1350px) {
//   // .carouselContainer .slick-slide {
//   //   margin: 0 0.5rem;
//   // }
//   .carouselContainer button.slick-next {
//     right: -30px;
//     width: 2rem;
//   }
//   .carouselContainer button.slick-prev {
//     // left: -30px;
//     left: -40px;
//     width: 2rem;
//   }
// }

@media not all and (min-resolution: 0.001dpcm) {
  @supports (-webkit-appearance: none) {
    .flex-col.w-full {
      width: 95% !important;
    }
  }
}

// .default-sidebar-width {
//   transition: 0.25s linear;
//   width: 100%;
//   float: right;
//   transition-property: all;
// }

//side content when sidebar grows
.sidebar-open-width {
  transition: 0.25s linear;
  width: 91.6%;
  float: right;
  transition-property: all;
}

@media only screen and (max-width: 768px) {
  .sidebar-open-width {
    width: 100%;
  }
}

//sidebar slide transition
.slide-leave-active,
.slide-enter-active {
  transition: 0.25s;
}
.slide-enter {
  transform: translate(-50%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}

//mobile backgorund fade
.fade-cross-button-enter-active,
.fade-cross-button-leave-active {
  transition: opacity 0.25s;
}
.fade-cross-button-enter,
.fade-cross-button-leave-to {
  opacity: 0;
}

//slide sidebar text
.slide-text-leave-active {
  transition-property: all;
  transition: 0.2s;
}
.slide-text-enter-active {
  transition-property: all;
  transition: 0.25s;
}
.slide-text-enter {
  opacity: 0;
  transform: translate(-40%, 0);
}
.slide-text-leave-to {
  opacity: 0;
  transform: translate(-90%, 0);
}

.required:after {
  content: " *";
  color: red;
}

.date-dropdowns {
  background: white;
  display: flex;
}

.fc-event-past {
  opacity: 0.5;
}

.fc-scroller{
  overflow: auto !important;
}

.fc-timegrid-axis-frame {
  font-size: xx-small;
  word-break: break-all;
}

.fc-v-event .fc-event-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  text-transform: capitalize;
}

// .container-max-width {
// margin: auto;
// max-width: 1440px;
// }

// Small devices (landscape phones, 576px and up)
@media (min-width: 640px) {
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
}

// Large devices (desktops, 992px and up)
@media (min-width: 1024px) {
}

// X-Large devices (large desktops, 1200px and up)
@media (min-width: 1280px) {
}

// XX-Large devices (larger desktops, 1400px and up)
@media (min-width: 1536px) {
}

.tooltip {
  position: relative;
  display: inline-block;
}

.tooltip .tooltiptext {
  visibility: hidden;
  // width: 120px;
  min-width: max-content;
  background-color: #444444;
  color: #fff;
  text-align: center;
  border-radius: 0.25rem;
  padding: 0.5rem 0.5rem;
  font-size: 0.75rem;

  /* Position the tooltip */
  position: absolute;
  z-index: 1;
  top: 2rem;
  left: 100%;
}

.tooltip-sidebar {
  position: relative;
  display: inline-block;
}

.tooltip-sidebar .tooltip-sidebar-text {
  visibility: hidden;
  min-width: max-content;
  background-color: #444444;
  color: #fff;
  text-align: center;
  border-radius: 0.25rem;
  padding: 0.5rem 0.5rem;
  font-size: 0.75rem;
  position: absolute;
  z-index: 1;
  top: 2rem;
  left: 100%;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
}

.tooltip-sidebar:hover .tooltip-sidebar-text {
  visibility: visible;
}

.shadow-all:hover {
  // width: 284px;
  // height: 344px;
  // margin: 0 0 0 134px;
  // box-shadow: 2px 4px 12px 0 rgba(0, 0, 0, 0.2);
  // box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.1);
  // box-shadow: 0 19px 38px rgba(0, 0, 0, 0.3), 0 15px 12px rgba(0, 0, 0, 0.22);
  box-shadow: 2px 6px 12px 0 rgba(0, 0, 0, 0.07),
    -2px -6px 12px 0 rgba(0, 0, 0, 0.14);
}
.shadow-no-hover{
  box-shadow: 2px 6px 12px 0 rgba(0, 0, 0, 0.07),
      -2px -6px 12px 0 rgba(0, 0, 0, 0.14);
}
// .modal {
//   font-family: "Montserrat";
// }

//global input box styling
.focus\:outline-none:focus {
    outline: 0px solid transparent;
    outline-offset: 0px;
}
[multiple]:focus, [type=date]:focus, [type=datetime-local]:focus, [type=email]:focus, [type=month]:focus, [type=number]:focus, [type=password]:focus, [type=search]:focus, [type=tel]:focus, [type=text]:focus, [type=time]:focus, [type=url]:focus, [type=week]:focus, select:focus, textarea:focus{
  border-color: rgba(204, 206, 220, var(--tw-border-opacity));
  box-shadow: none;
}
.border{
  border-width:0;
}
.divide-y>:not([hidden])~:not([hidden]) {
    --tw-divide-y-reverse: 0;
    border-bottom-width: calc(1px*var(--tw-divide-y-reverse));
    border-top-width: 0;
}
.ui.fluid.dropdown{
  line-height: 1.7!important;
  .dropdown.icon{
    top: 27px!important;
    background-image: url("./assets/img/select-chevron.png");
    background-repeat: no-repeat;
    border-color: #cccedc!important;
    &::before{
      content: none;
    }
  }
  .text{
    color: #6B7280;
  }
  .search{
    height: 46px;
  }
  @media (max-width: 640px){
    height: auto;
  }
}
.vue-phone-number-input{
  .country-selector__input,.input-tel__input{
    height: 48px!important;
    border-color: #cccedc!important;
  }
}

//fc calendar styling
.user-calendar{
  margin-bottom: 2rem;
}
.fc{
    .fc-header-toolbar{
      margin-top: 1rem;
      @media (max-width: 650px){
        flex-direction: column;
        padding-bottom: 10px;
        padding-top: 10px;
        .fc-toolbar-title{
          margin-bottom: 5px;
          margin-top: 5px;
        }
      }
      .fc-toolbar-chunk{
        .fc-button-primary{
          font-size: 1rem;
          @media (max-width: 992px){
            font-size: 0.75rem;
          }
          border-color: #cccedc;
          &.fc-button-active{
            border-color: #cccedc!important;
            &:active{
              &:focus{
                box-shadow: none;  
              }
            }
            &:focus{
              box-shadow: none;
            }
          }
        }
        .fc-toolbar-title{
            font-size: 18px!important;
          }
        @media (max-width:992px){
          .fc-toolbar-title{
            font-size: 13px!important;
          }
        }
      }
    }
    .fc-view-harness{
      .fc-view{
        .fc-scrollgrid {
          border: 0;
          .fc-col-header-cell-cushion {
            font-weight: 400;
            color: #768296;
            font-size: 14px;
          }
        }
        &.fc-timegrid{
          .fc-timegrid-body{
            .fc-timegrid-slots{
              .fc-timegrid-slot-label-cushion{
                font-size: 14px;
                color: #768296;
              }
            }
            
          }

        }
        &.fc-daygrid{
          .fc-daygrid-day-number{
            font-size: 14px;
            color: #444444;
          }
        }
      }
    }
  }

//input tage remove icon spacing
.vue-input-tag-wrapper{
  .input-tag{
    .remove{
      padding-left: 8px;
    }
  }
}

//slick slider css
.slick-slider {
  .slick-dots{
    position: static;
    margin-top: 15px;
    li{
      margin: 0;
      width: auto;
      height: auto;
      margin-right: 10px;
      &:last-child{
        margin-right: 0;
      }
      button{
        background-color: #999;
        border-radius: 50%;
        width: 12px;
        height: 12px;
        &:before{
          content: none;
        }
      }
      &.slick-active{
        button{
          background-color: #8DC73F;
          width: 16px;
          height: 16px;
        }
      }
    }
  }
  .content{
    &::after{
      content: "";
      width: 100%;
      position: absolute;
      height: 100%;
      background: linear-gradient(90deg, #3C3C3C -13.26%, rgba(0, 0, 0, 0) 97.61%);
    }
  }

}

// global checkbox color
input[type="checkbox"] {
  border-radius: 0.2rem;
}
input[type="checkbox"]:checked {
  background-color:#99c355 !important;
}
input[type="checkbox"]:focus{
  box-shadow: none !important;
}
</style>